// extracted by mini-css-extract-plugin
export default {"headers":"style_headers__OD-ip","head":"style_head__t5Z9T","price":"style_price__6Gq96","balance":"style_balance__8Olju","symbol":"style_symbol__oKAio"};